import React, { useState, useEffect, useRef } from "react";
import {
  FaCrown,
  FaShieldAlt,
  FaHeart,
  FaGlobe,
  FaArrowRight,
} from "react-icons/fa";
import "../Vender/css/LuxuryFeatures.css";

const LuxuryFeatures = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const features = [
    {
      icon: <FaCrown />,
      title: "Premium Luxury",
      description:
        "Experience unparalleled comfort with our handpicked luxury accommodations and world-class amenities.",
      color: "#f59e0b", // Gold
    },
    {
      icon: <FaShieldAlt />,
      title: "Trusted Excellence",
      description:
        "10+ years of creating magical experiences with complete safety and reliability for our valued guests.",
      color: "#6366f1", // Indigo
    },
    {
      icon: <FaHeart />,
      title: "Personalized Care",
      description:
        "Every journey is crafted with love and attention to detail, ensuring your perfect holiday experience.",
      color: "#ef4444", // Red
    },
    {
      icon: <FaGlobe />,
      title: "Global Destinations",
      description:
        "Explore 150+ breathtaking destinations worldwide with our extensive network of premium partners.",
      color: "#06b6d4", // Cyan
    },
  ];

  const stats = [
    { number: "50K+", label: "Happy Travelers" },
    { number: "150+", label: "Destinations" },
    { number: "500+", label: "Luxury Hotels" },
    { number: "10+", label: "Years Experience" },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`membership-section ${isVisible ? "is-visible" : ""}`}
      ref={sectionRef}
    >
      {/* Background Elements */}
      <div className="membership-bg">
        <div className="bg-gradient"></div>
        <div className="bg-pattern"></div>
        <div className="floating-shapes">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div className="membership-wrapper">
        {/* Header */}
        <header className="membership-header">
          <div className="header-badge">
            <span className="badge-dot"></span>
            Our Promise
          </div>
          <h2 className="header-title">
            Crafted for <span className="title-highlight">Discerning</span>{" "}
            Travelers
          </h2>
          <p className="header-subtitle">
            Where elegance meets exceptional service, creating memories that
            last a lifetime.
          </p>
        </header>

        {/* Features Grid */}
        <div className="benefits-grid features-layout">
          {features.map((feature, index) => (
            <div
              key={index}
              className="benefit-card feature-card-style"
              style={{
                "--delay": `${index * 0.1}s`,
                "--accent": feature.color,
              }}
            >
              <div className="card-border"></div>
              <div className="card-glow"></div>

              <div className="card-content vertical">
                <div className="card-icon-wrapper">
                  <div className="card-icon">{feature.icon}</div>
                  <div className="icon-ring"></div>
                </div>

                <div className="card-info center-text">
                  <h3 className="card-title">{feature.title}</h3>
                  <p className="card-desc">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Split Showcase Section */}
        <div className="showcase-split">
          <div className="showcase-image-container">
            <div className="image-card-border"></div>
            <img
              src="/assets/images/aboutus-content_img.jpg"
              alt="Luxury Experience"
              className="showcase-img"
            />
          </div>

          <div className="showcase-text-content">
            <h3 className="showcase-heading">Excellence in Every Detail</h3>
            <p className="showcase-para">
              We believe that luxury is not just about opulence, but about
              creating meaningful experiences that resonate long after your
              journey ends. Every element is carefully curated to exceed your
              expectations.
            </p>

            <div className="mini-stats-grid">
              {stats.map((stat, index) => (
                <div key={index} className="mini-stat-item">
                  <span className="mini-stat-num">{stat.number}</span>
                  <span className="mini-stat-lbl">{stat.label}</span>
                </div>
              ))}
            </div>

            {/* <a href="/explore" className="cta-button primary">
              <span className="btn-text">Explore More</span>
              <div className="btn-icon">
                <FaArrowRight />
              </div>
              <div className="btn-shine"></div>
            </a> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LuxuryFeatures;
